export var CONTAINER_NAME = {
  WECHAT: 'wechatMiniProgram',
  ALIPAY: 'aliMiniApp',
  BYTE: 'bytedanceMicroApp',
  WEB: 'web',
  BAIDU: 'baiduSmartProgram',
  KWAI: 'kuaishouMiniProgram',
  NODE: 'node'
};
export var JSONP_SIGN = '__uni_jsonp_handler_sign__';